import React, { useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import { LenguageTabla } from "../../Comunes/LenguajeTabla/LenguajeTabla";
import moment from "moment";
import $ from "jquery";
import ModificarPeriodoModal from "./ModificarPeriodoModal";

function OperacionesDelDeudor({
  operaciones,
  actualizarOperaciones = null,
  permiteSeleccionar = false,
  permiteEliminar = false,
  permiteEditar = false,
}) {
  const tableRef = useRef();

  useEffect(() => {
    const tabla = $(tableRef.current).DataTable({
      language: LenguageTabla,
      pageLength: 10,
      processing: true,
      destroy: true,
      data: operaciones,
      select: permiteSeleccionar && {
        style: "os",
        selector: "td:first-child",
      },
      columns: [
        {
          title: "Selecionar",
          data: null,
          defaultContent: "",
          className: "select-checkbox",
          searchable: false,
          orderable: false,
          visible: permiteSeleccionar,
        },
        {
          title: "Editar",
          data: null,
          createdCell: function (cell, cellData, rowData, rowIndex, colIndex) {
            function actualizarPeriodoInicio(operacion) {
              tabla.row(rowIndex).data(operacion).draw(false);
              actualizarOperaciones(tabla.rows().data().toArray());
            }

            ReactDOM.render(
              <div className="d-flex justify-content-between">
                <div className="mr-4">
                  <ModificarPeriodoModal
                    Operacion={cellData}
                    actualizarPeriodoInicio={actualizarPeriodoInicio}
                  />
                </div>
              </div>,
              cell
            );
          },
          searchable: false,
          orderable: false,
          visible: permiteEditar,
        },
        {
          title: "Operación",
          data: "operacion",
        },
        {
          title: "Periodo Inicial",
          data: "periodoInicio",
          render: function (row) {
            return row !== null ? moment(row).format("DD/MM/YYYY") : "";
          },
        },
        {
          title: "Periodo Final",
          data: "periodoFin",
          render: function (row) {
            return row !== null ? moment(row).format("DD/MM/YYYY") : "";
          },
        },
      ],
      columnDefs: [
        {
          targets: 0,
          defaultContent: "",
          className: "select-checkbox",
          searchable: false,
          orderable: false,
          visible: permiteSeleccionar,
        },
      ],
    });

    tabla.off("click");

    tabla.on("select deselect", function (e) {
      if (tabla.rows({ selected: true }).data().count() === 1)
        actualizarOperaciones(tabla.rows({ selected: true }).data().toArray());
    });

    tabla.on("click", "tr", function () {
      if ($(this).hasClass("selected")) {
        $(this).removeClass("selected");
      } else {
        tabla.$("tr.selected").removeClass("selected");
        $(this).addClass("selected");
      }
    });
  }, [
    operaciones,
    actualizarOperaciones,
    permiteSeleccionar,
    permiteEliminar,
    permiteEditar,
  ]);

  return (
    <div className="card shadow mb-4">
      <div className="card-header">
        <h6 className="m-0 font-weight-bold text-primary">Operaciones</h6>
      </div>
      <div className="card-body">
        {permiteSeleccionar ? (
          <div className="alert alert-danger" role="alert">
            Mediante esta solicitud se eliminarán todos los registros
            relacionados a la operación: Operación No Reportada, Cuotas
            Atrasadas, Garantías, Codeudores y Operación Saldo Cuentas por
            Cobrar asociadas a la Operación.
          </div>
        ) : null}

        <table
          className="table table-striped table-hover w-auto display ejemplo"
          ref={tableRef}
        />
      </div>
    </div>
  );
}

export default OperacionesDelDeudor;
